import React, { useState } from 'react'

import { useQuery } from '@tanstack/react-query'

import { Flex, InlineAlert } from '@driftt/dds'

import { fetchAllFastlanePlaybooks } from 'api/conversation/playbooks'
import useLocalStorage from 'hooks/useLocalStorage'
import { userWillGetFastlaneAlertInMeetingsReport } from 'utils/access'

const FastlaneAlert = () => {
  const [showAlert, setShowAlert] = useLocalStorage('showFastlaneAlert', true)
  const [fastlanePlaybooksEnabled, setFastlanePlaybooksEnabled] =
    useState(false)

  useQuery({
    queryKey: ['fastlanePlaybooks'],
    queryFn: fetchAllFastlanePlaybooks,
    onSuccess(data) {
      const fastlanePlaybooks = Object.values(data)
      if (fastlanePlaybooks.length === 0) {
        setFastlanePlaybooksEnabled(false)
      } else {
        setFastlanePlaybooksEnabled(true)
      }
    },
  })

  if (
    !userWillGetFastlaneAlertInMeetingsReport() ||
    fastlanePlaybooksEnabled ||
    !showAlert
  ) {
    return null
  }

  return (
    <Flex
      direction="column"
      gap={3}
      fullWidth
      css={{
        padding: '$2 $2 $3',
      }}
    >
      <Flex.Item alignSelf="stretch">
        <InlineAlert
          title="Book more meetings with Fastlane"
          description="Drift customers more than double the number of meetings booked by using Fastlane.
        Have qualified, high-intent leads skip the queue and book a meeting immediately after submitting a form!"
          variant="info"
          onClose={() => setShowAlert(false)}
          dismissable
        />
      </Flex.Item>
    </Flex>
  )
}

export default FastlaneAlert
